import { show } from 'redux-modal'
import { VEHICLE_EDITOR_MODAL } from 'constant'

export const openVehicleEditor = ({ userVehicleId }) =>
  show(VEHICLE_EDITOR_MODAL, { userVehicleId })
